import { Component, inject } from '@angular/core';
import { PAGE_DATA } from 'src/types/tokens/inject-tokens';

@Component({
  standalone: true,
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  imports: [],
})
export class AppPageTitleComponent {
  private componentData: any = inject(PAGE_DATA, { optional: true });

  title!: string;

  constructor() {
    if (this.componentData.title) {
      this.title = this.componentData.title;
    }
  }
}
